export const environment = {
  production: true,
  buildId: '3102058937120531',
  configFile: 'config.json',
};
